<template>
    <div class="p-3">
        <b-card
            title="Tambah Mater Loket"
        >
            <b-card-text>
                <form class="mt-5">
                    <div class="form-group row pb-4">
                        <label class="col-lg-3 text-lg-end pt-2" for="select-poli">Kategori</label>
                        <div class="col-lg-6">
                            <select2 id="select-poli" v-model="form.kategori" :options="all_kategori_options" @change="getKonfigurasiKuotaPoli"></select2>
                        </div>
                    </div>
                    <div class="form-group row pb-4">
                        <label class="col-lg-3 text-lg-end pt-2" for="select-poli">Nama Loket</label>
                        <div class="col-lg-6">
                            <b-form-input type="text" v-model="form.nama"></b-form-input>
                        </div>
                    </div>

                    <div class="form-group row pb-4">
                        <div class="col-lg-3 text-lg-end pt-2"></div>
                        <div class="col-lg-6">
                            <b-button size="sm" variant="primary" @click="createMasterLoket">Simpan</b-button>
                            <b-button size="sm" variant="danger" @click="cancelAdd">Batal</b-button>
                        </div>
                    </div>
                </form>
            </b-card-text>
        </b-card>
    </div>
</template>

<script>
import Select2 from 'v-select2-component'

export default {
    components: {
        Select2
    },
    data() {
        return {
            user: null,
            access_token: null,
            form: {
                kategori: 0,
                nama: '',
            },
            all_kategori_options: [{id: 0, text: '--- Pilih Kategori ---'}]
        }
    },
    created() {
        this.getAuth()
    },
    methods: {
        getAuth() {
            this.user = localStorage.getItem('user')
            this.access_token = localStorage.getItem('access_token')

            this.getAllKategoriOptions()
        },
        getAllKategoriOptions() {
            this.$isLoading(true)
            let uri = '/api/get_all_kategori_options'

            let headers = {
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + this.access_token
                }
            }

            this.axios.get(uri, headers).then(response => {
                this.all_kategori_options = [{id: 0, text: '--- Pilih Kategori ---'}]

                let kategori = response.data.kategori
                kategori.forEach(cat => {
                    this.all_kategori_options.push({id: cat.id, text: cat.nama})
                });

                this.$isLoading(false)
            }).catch((error) => {
                this.$isLoading(false)
                let response = error.response != undefined ? error.response : null
                if (response) {
                    if (response.status == 401) {
                        localStorage.setItem('access_token', '')
                        localStorage.setItem('user', '')
                        location.href = '/login'
                    }
                }
            })
        },
        createMasterLoket() {
            this.$isLoading(true)
            let uri = '/api/konf_master_loket'

            let headers = {
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + this.access_token
                }
            }

            this.axios.post(uri, this.form, headers).then(response => {
                if (response.data.status == 'success') {
                    this.$swal.fire({
                        title: 'Success!',
                        text: 'Loket Berhasil Dibuat!',
                        icon: 'success',
                        confirmButtonText: 'OK'
                    })
                } else {
                    this.$swal.fire({
                        title: 'Error!',
                        text: response.data.message,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                }

                this.$isLoading(false)
            }).catch((error) => {
                this.$isLoading(false)
                let response = error.response != undefined ? error.response : null
                if (response) {
                    if (response.status == 401) {
                        localStorage.setItem('access_token', '')
                        localStorage.setItem('user', '')
                        location.href = '/login'
                    }
                }
            })
        },
        cancelAdd() {
            this.$router.push('konfigurasi-master-loket')
        }
    }
    
}
</script>